/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type ContractProposalBaseSolutionHorizonType =
  (typeof ContractProposalBaseSolutionHorizonType)[keyof typeof ContractProposalBaseSolutionHorizonType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractProposalBaseSolutionHorizonType = {
  short_term: "short_term",
  mid_term: "mid_term",
  long_term: "long_term",
} as const;
